import { PopulationQualifierKind } from "@redotech/redo-billing-common/checkout-optimization-qualifier";
import * as z from "zod";

/**
 * Exclude a leaf population on the ACTIVE tree from billing. Trusted users
 * only; `kind` omitted suppresses every population qualifier.
 */
export const writeCheckoutExclusion = {
  name: "writeCheckoutExclusion" as const,
  input: z.object({
    checkoutTreeNodeId: z.string(),
    kind: z.nativeEnum(PopulationQualifierKind).optional(),
    note: z.string().min(1),
  }),
  output: z.null(),
};
